import * as React from "react";
import { Item, Button } from "semantic-ui-react";

import { OhCaseDocument } from "../../crud/ohCase/model";
import { EmployeeDocument } from "../../crud/employeeRecord/model";

interface CaseTaskCardProps {
    document: OhCaseDocument | EmployeeDocument;
    downloadUrl: string;
    title: string;
}

export class DocumentCard extends React.Component<CaseTaskCardProps> {
    public render() {
        const downloadUrl = `${this.props.downloadUrl}/${this.props.document.id}?fileName=${this.props.document.name}`;
        return (
            <Item>
                <Item.Content>
                    <Item.Header>{this.props.title} - {this.props.document.name}</Item.Header>
                    <Item.Extra>
                        {this.props.children}
                    </Item.Extra>
                    <Item.Extra>Document type: {this.props.document.documentType}</Item.Extra>
                    <Item.Extra>Created: {this.props.document.dateCreated.format("L")}</Item.Extra>
                    <a href={downloadUrl}>
                        <Button content="Download" type="button" floated="right" />
                    </a>
                </Item.Content>
            </Item>
        );
    }
}
